export const SideDesign = () => {
  return (
    <div>
      <img
        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/LeftSideDesign.png"
        alt="left"
        style={{
          left: 0,
          bottom: "0",
          height: "auto",
          zIndex: 1,
          position: "fixed",
          width: "120px",
        }}
      />
      <img
        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/RightSideDesign.png"
        alt="right"
        style={{
          right: 0,
          top: "35%",
          height: "auto",
          zIndex: 1,
          position: "fixed",
          width: "50px",
        }}
      />
    </div>
  );
};
